import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Page } from 'app/classes/page';
import { Account } from 'app/constants/account.enum';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { CountryISO } from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import {BehaviorSubject, Observable} from 'rxjs';
declare var $;
@Injectable()
export class UtilityServiceService {

  approveStatusId:any=51;
  isCarrier:boolean=false;
  isProcessAccounts:boolean=false;
  permitFreightId:any="";
  displayIndicators = [{ key: 0, value: 'None' }, { key: 1, value: 'Internal' }, { key: 2, value: 'External' }, { key: 3, value: 'Both' }];
  //statusUseIndicators = [{ key: 0, value: 'None' }, { key: 1, value: 'Permit' }, { key: 2, value: 'Application' }, { key: 3, value: 'Application & Permit' }];
  statusUseIndicators = [{ key: 0, value: 'none' }, { key: 1, value: 'carrier' }, { key: 2, value: 'permit' }, { key: 3, value: 'application' }, { key: 4, value: 'permit and permit application' }, { key: 5, value: 'permit, permit application & carrier' }];
  entityType = [{ key: 0, value: 'None' }, { key: 1, value: 'Company' }, { key: 2, value: 'Individual' }];
  defaults = { sort_order: 1, group_code: 'A', is_active: true };
  flags = { flagID: 1, flagCE: 1, flagDN: 1, flagAE: 1, flagGC: 1, flagSO: 1,flagPV:1, flagPM:1 };
  ranks = { flagID: 0, flagCE: 1, flagDN: 2, flagAE: 3, flagGC: 4, flagSO: 5,flagPV:6, flagPM:7 };
  sortLabels = { flagID: "id", flagCE: "code", flagDN: "description", flagAE: "is_active", flagGC: "group_code", flagSO: "sort_order", flagPV:"province_id", flagPM:"permit_num" };
  ctrlPages: any = [];
  rolesServed = [{ key: 1, value: 'Lead User' }, { key: 2, value: 'Editor User' }, { key: 6, value: 'Read User' }, { key: 11, value: 'Owner' }, { key: 12, value: 'Consultant' }, { key: 21, value: 'Main Contact' }];
  // idTypes = [{ key: 0, value: 'Unknown' }, { key: 1, value: 'Local ID Number' }, { key: 2, value: 'Foreign Passport/ID Number' }, { key: 3, value: 'Company Registration Number' }, { key: 4, value: 'NPO Number' }, { key: 5, value: 'Trust Number' }];
  idTypes = [{ key: 0, value: 'Unknown' },
        { key: 1, value: 'ID Number' },
        { key: 2, value: 'Foreign Passport / ID Number' },
        { key: 3, value: 'Company Registration Number' },
        { key: 4, value: 'NPO Number' },
        { key: 5, value: '(key 5)' },
        { key: 6, value: 'Closed Corporation Reg No'},
        { key: 7, value: 'Trust Registration No'},
        { key: 8, value: 'ID Number of Main Partner'},
      ];
  freight_passenger_inds = [{ key: 1, value: 'Freight' }, { key: 2, value: 'Passenger' }, { key: 3, value: 'Both' }]
  bbbees = [
    { text: 'Level 1' },
    { text: 'Level 2' },
    { text: 'Level 3' },
    { text: 'Level 4' },
    { text: 'Level 5' },
    { text: 'Level 6' },
    { text: 'Level 7' },
    { text: 'Level 8' },
    { text: 'Non-compliant' }
  ];
  numberisvalid: boolean;
  listStops = [
    { key: 1, value: "Departure point" },
    { key: 2, value: "Loading point" },
    { key: 3, value: "Offloading point" },
    { key: 4, value: "Loading/Offloading point" },
    { key: 5, value: "Refreshment stop" },
    { key: 6, value: "Refuelling stop" },
    { key: 9, value: "Destination point" }
  ];

  businessTypes = [
    { key: 1, value: 'Private Company' },
    // { key: 2, value: 'Close Corporation' },
    { key: 2, value: 'Closed Corporation' },
    { key: 3, value: 'Public Company' },
    { key: 11, value: 'One-Person Business' },
    { key: 12, value: 'Partnership' },
    { key: 21, value: 'Other' }
  ];
  preferredCountries: CountryISO[] = [
    CountryISO.Angola,
    CountryISO.Botswana,
    CountryISO.Comoros,
    CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
    CountryISO.Lesotho,
    CountryISO.Madagascar,
    CountryISO.Malawi,
    CountryISO.Mauritius,
    CountryISO.Mozambique,
    CountryISO.Namibia,
    CountryISO.Seychelles,
    CountryISO.Swaziland,
    CountryISO.Zambia,
    CountryISO.Zimbabwe,
  ];

  pageItems = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  acc = Account;
  direction = true;
  rankCtrl = 2;
  btnAction:any=0;
  docCtrl:boolean = false;
  confirmCtrl: boolean = false;
  saveconfirmCtrl: boolean = false
  dontAllowConfirm: boolean = false;
  criteria = this.sortLabels.flagSO;
  sortOrderList = [1, 2, 3, 4];
  activeTab = 1;
  page = 1;
  isView: boolean = true;
  isBtnVisible: boolean = true;
  currentActive = 1;
  isChanged:boolean = false;
  actionStatus:any="";
  permitType:any="";
  permitAppId: any = null;
  carrierId: number = 0;
  carrierName: string = '';
  timetableActive:boolean=false;
  private showStatementFooterSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showStatementFooter$: Observable<boolean> = this.showStatementFooterSubject.asObservable();

  sequenceNumbers: any = {
    permitNum: 1,
    vehicleNum:2,
    routesNum: 3,
    timeTableNum: 0,
    motivationNum: 4,
    uploadsNum: 5,
    cnfNum: 6
  };
  changeKey = 0;
  permitStatusId:any="";
  carrierStatusId:any="";
  carrierObject: any = null;
  compliance: any = null;
  cplURL = 'calendar/viewer';
  constructor(private datePipe: DatePipe, private router: Router) {
    this.ctrlPages = this.initPages();
  }

  showDisplayIndicator( key: number = 0) {
    let label: string = null;
    switch (key) {
      case 1:
        label = 'Internal';
        break;
      case 2:
        label = 'External';
        break;
      case 3:
        label = 'Both';
        break;
      default:
        label = 'None';
        break;
    }
    return label;
  }

  showStatusIndicator(key: number = 0) {
    let label: string = null;
    switch (key) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        label = this.statusUseIndicators[key].value;
        break;
      default:
        label = 'None';
        break;
    }
    return label;
  }

  setDirection(direction){
    this.direction = direction;
  }

  setShowStatementFooter(value: boolean): void {
    this.showStatementFooterSubject.next(value);
  }

  isActive(active: boolean = false) {
    return (active) ? 'Yes' : 'No'
  }

  onSort(rank: number) {
    this.direction = !this.direction;
    this.rankCtrl = rank;
    this.onExcuteSort(rank);
  }

  onResetFlags() {
    this.flags = { flagID: 1, flagCE: 1, flagDN: 1, flagAE: 1, flagGC: 1, flagSO: 1, flagPV:1, flagPM:1 };
    this.page = 1;
  }

  onExcuteSort(rank: number) {
    this.onResetFlags();
    const sort = (this.direction) ? 3 : 2;
    this.criteria = null;
    switch (rank) {
      case this.ranks.flagCE: {
        this.criteria = this.sortLabels.flagCE;
        this.flags.flagCE = sort;
        break;
      }
      case this.ranks.flagDN: {
        this.criteria = this.sortLabels.flagDN;
        this.flags.flagDN = sort;
        break;
      }
      case this.ranks.flagAE: {
        this.criteria = this.sortLabels.flagAE;
        this.flags.flagAE = sort;
        break;
      }
      case this.ranks.flagGC: {
        this.criteria = this.sortLabels.flagGC;
        this.flags.flagGC = sort;
        break;
      }
      case this.ranks.flagSO: {
        this.criteria = this.sortLabels.flagSO;
        this.flags.flagSO = sort;
        break;
      }
      case this.ranks.flagID: {
        this.criteria = this.sortLabels.flagID;
        this.flags.flagID = sort;
        break;
      }
      case this.ranks.flagPV: {
        this.criteria = this.sortLabels.flagPV;
        this.flags.flagPV = sort;
        break;
      }
      case this.ranks.flagPM: {
        this.criteria = this.sortLabels.flagPM;
        this.flags.flagPM = sort;
        break;
      }
    }

  }

  setAuditAttributes(dateC: Date, usernameC: string, dateU: Date, usernameU: string) {
    return {
      created: `On ${this.datePipe.transform(dateC, 'yyyy-MM-dd')} <b>${this.datePipe.transform(dateC, 'h:mm a')}</b> by ${usernameC}`,
      updated: `On ${this.datePipe.transform(dateU, 'yyyy-MM-dd')} <b>${this.datePipe.transform(dateU, 'h:mm a')}</b> by ${usernameU}`
    };

  }

  public nextPage = (id: number): void => {
    ////console.log(`Going to ${id} next page  ${this.ctrlPages[id].next}`)
    if (this.ctrlPages[id].next > -1) {
      this.ctrlPages[this.ctrlPages[id].next - 1].visibility = true;
      this.ctrlPages[id].visibility = false;
    }
  }

  public prevPage = (id: number): void => {

    if (this.ctrlPages[id].previous > -1) {
      this.ctrlPages[this.ctrlPages[id].previous - 1].visibility = true;
      this.ctrlPages[id].visibility = false;
    }

  }

  public navigate = (url: string): void => {
    this.router.navigateByUrl(url);
  }

  landingPage = () => {
    this.ctrlPages = this.initPages();    
    if(this.isProcessAccounts)
    {
      this.navigate('/account/approval');
    }
    else
    if(this.isCarrier){
      this.currentActive=1;
      this.page=1;
      this.isCarrier=false;
    }else{
      this.navigate('/carrier/accounts');
    }

  }

  initPages = () => {

    return [
      new Page(1, {}, 2, -1, false, false),
      new Page(2, {}, 3, 1, false, false),
      new Page(3, {}, 4, 2, false, false),
      new Page(4, {}, 5, 3, false, false),
      new Page(5, {}, -1, 4, false, false)
    ];
  }

  switchOnVisibility = (page_num: number) => {
    this.ctrlPages.filter(page => page.id != page_num).forEach(others => others.visibility = false);
    this.ctrlPages[page_num].visibility = true;
  }

  checkIntegerType(control: UntypedFormControl) {
    let statusValue = control.value;
    if (statusValue) {
      let intValue = /^\d*$/.test(statusValue);
      if (!intValue) {
        return {
          checkInt: {
            negative: statusValue
          }
        }
      }
      return null;
    }
  }

  onBackward = () => {
    this.currentActive = 1;
  }


  initTooltip = () => {
    $(document).ready(function () {
      $('[rel="tooltip"]').tooltip(
        {
          trigger: 'hover',
          delay: { show: 100, hide: 100 }
        }
      );


    $('[rel="tooltip"]').on('click', function (e) {
      e.preventDefault();
       $(this).tooltip('hide');
       $(this).tooltip('dispose');
      })
    });
  }

  tabPosition = (tabNum) => {
    return tabNum - 1;
  }

  nextTabPosition = (tabNum) => {
    return tabNum + 1;
  }
}
